// extracted by mini-css-extract-plugin
module.exports = {"industry-check-list__wrapper":"industry-check-list__wrapper","industry-check-list__heading":"industry-check-list__heading"};